module.exports = __webpack_public_path__ + "img/nick-liefhebber-creativity-and-the-arts.c442706.jpg";